import classnames from "classnames"
import React from "react"
import { ContainerQuery } from "react-container-query"
import { useTranslation } from "react-i18next"
import Obfuscate from "react-obfuscate"

import Button from "@atoms/Button/Button"
import SecondaryString from "@atoms/SecondaryString/SecondaryString"
import "@lang/i18n"

import styles from "./Building.module.scss"

const query = {
  "width-min-576": {
    minWidth: 576,
  },
  "width-max-575": {
    maxWidth: 575,
  },
  "width-max-480": {
    maxWidth: 480,
  },
  "width-max-349": {
    maxWidth: 349,
  },
}

const Building = ({
  name,
  address,
  email,
  phone,
  openingHours,
  location,
  directionsLink,
  marker,
  headingSize = "h3",
}) => {
  const { t } = useTranslation()

  const markerUrl = Number.isInteger(marker)
    ? `/media/markers/${marker}.png`
    : "/media/markers/1.png"

  const Heading = headingSize

  // If we have specific url for directions, then use it.
  // If not, then check that we have sane coordinates and then use those for a link.
  // Otherwise, no link for this building.
  const directionsLinkUrl = directionsLink
    ? directionsLink
    : location?.lat && location?.lng
    ? `https://www.google.com/maps/dir/Current+Location/${location.lat},${location.lng}`
    : ``

  return (
    <ContainerQuery query={query}>
      {(params) => (
        <div className={classnames(params)}>
          <div className={styles.item}>
            {marker && (
              <div className={styles.image}>
                <img src={markerUrl} alt="" aria-hidden="true" />
              </div>
            )}
            <div className={styles.content}>
              <Heading>{name}</Heading>
              <p>{address}</p>
              <ul>
                {email && (
                  <li>
                    <Obfuscate element="span" email={email} />
                  </li>
                )}
                {phone && <li>{phone}</li>}
              </ul>
              <SecondaryString>{openingHours}</SecondaryString>
            </div>
            {directionsLinkUrl && (
              <div className={styles.cta}>
                <Button
                  variant="primary"
                  size="small-arrow"
                  href={directionsLinkUrl}
                  linkTarget="_blank"
                >
                  {t("Directions")}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </ContainerQuery>
  )
}

export default Building
